import ApiService from "@/core/services/api.service";
//import JwtService from "@/core/services/jwt.service";

// action types
export const GET_USER_MENU = "getUserMenu";

// mutation types
export const SET_USER_MENU = "setUserMenu";

const state = {
    
    user_menu: {}
    
};

const getters = {
    currentUserMenu(state) {
        return state.user_menu;
    },

};

const actions = {
    
    [GET_USER_MENU](context) {
        //JwtService.getToken();
        //ApiService.setHeader();
        ApiService.get("/auth/user-menu").then(({ data }) => {
            context.commit(SET_USER_MENU, data);
        });
    },
    
};

const mutations = {
    [SET_USER_MENU](state, user_menu) {
        state.user_menu = user_menu;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};

